import { createStore, withProps, select } from '@ngneat/elf';
import { ShopOffersInventory } from '@app/shared/models/inventory.model';
import { persistState } from '@ngneat/elf-persist-state';
import { slotcomStorageStrategy } from '../slotcom.storage';

export function createInitialState(): ShopOffersInventory {
  return {
    Coins: [],
    Gems: [],
  };
}

export const shopRatesStore = createStore({ name: 'shop-rates' }, withProps<ShopOffersInventory>(createInitialState()));

export const persist = persistState(shopRatesStore, {
  key: 'shop-rates',
  storage: slotcomStorageStrategy,
});

export const shopRates$ = shopRatesStore.pipe(select((state) => state));
export const coinRates$ = shopRatesStore.pipe(select((state) => state.Coins));
export const gemRates$ = shopRatesStore.pipe(select((state) => state.Gems));
